import axios from 'axios';
import { USER_LOGOUT, USER_AUTH_SUCCESS, GET_USER, SET_CONFIGURATION } from "../mutation-types";
import Api from '@/Api'

const state = {
  token: localStorage.getItem('rogg_token') || '',
  user: JSON.parse(localStorage.getItem('rogg_user')) || {},
  configuration:{
    enabled:0,
    background:'',
    discounts:[]
  }
};

const getters = {
  isLogged: state => !!state.token,
  user: state => state.user,
  //purchaseMin: state => state.user.purchase_min, // 500
  purchaseMin: state => 0, // 500
  discounts: state => state.user.discounts,
  configuration:state=>state.configuration
};

const actions = {
  login (store, { email, password }) {
    return new Promise((resolve, reject) => {

      Api().post('login', {username:email, password,})
        .then(({ data }) => {
            if (data.token) {

              store.commit(USER_AUTH_SUCCESS, { user: data.user, token: data.token });

              /* CALL CART LOADER */
              store.dispatch("loadCartFromStorage", {}).then( () =>{
                resolve();
              }).catch(err=>{
                resolve();
              });

            } else {
              reject(data.error);
            }
        }).catch((err) => {
            if (err.response.data.error)
            {
              reject(err.response.data.error);
            }else
            {
              reject('No pudimos conectarnos con el servidor!');
            }

        });

    });
  },
  register (store, { nombre,cuit,calle,numero,piso,depto,localidad,provincia_id,email,password,password_repeat }) {
    return new Promise((resolve, reject) => {
      if (password !== password_repeat) reject('la clave y la repeticción es invalida');
      Api().post('register', {cuit,email,password,password_repeat})
        .then(({ data }) => {
          if (data!==""){
            if (data.success) {
              resolve();
            } else {
              reject(data.error.message);
            }
          }else{
            reject('el servidor no pudo procesar el registro.');
          }

        }).catch(error => {
          reject(error);
      });
    });
  },
  setConfiguration(store,data){
    store.commit(SET_CONFIGURATION,data);

  },
  getUser (store, {}) {

    return new Promise((resolve, reject) => {

      if (!localStorage.rogg_token){
        reject("not_prev_user");
        return;
      }

      Api().get('user', {
        }).then(data=>{
            store.commit(GET_USER, { user: data.data.data});

            resolve(data.data.data);
        }).catch(err=>{
          reject(err);
        });
    });
  }
  ,
  logout (store) {
    store.commit(USER_LOGOUT);
  }
};

const mutations = {
  [SET_CONFIGURATION] (store,data){
    store.configuration = data;
  },
  [GET_USER] (store, { user }) {
    store.user = user;
    store.error = '';
    localStorage.setItem('rogg_user', JSON.stringify(user));
  },
  [USER_AUTH_SUCCESS] (store, { user, token }) {
    store.user = user;
    store.error = '';
    store.token = token;
    localStorage.setItem('rogg_token', token);
    localStorage.setItem('rogg_user', JSON.stringify(user));
    axios.defaults.headers.common['Authorization'] = "Bearer " + localStorage.rogg_token;
  },
  [USER_LOGOUT] (store) {
    store.user = {};
    store.token = '';
    localStorage.clear();
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js